module.exports = __webpack_public_path__ + "img/2_3_3.538799c7.png";